import { useCallback } from 'react';

import { useHistory } from 'src/services/useHistory';
import { ROUTES } from 'src/routes';
import { useSharePopup } from 'src/services/popup';
import { useMainActions } from '../../store';
import { usePageEvents } from '../../services';

export const useHandlers = () => {
  const history = useHistory();
  const openShapePopup = useSharePopup();
  const mainActions = useMainActions();
  const { trackShareClicked } = usePageEvents();

  const handleShareClick = useCallback(() => {
    trackShareClicked();

    const shareDocumentId = mainActions.getShareDocumentId();
    openShapePopup({ shareDocumentId });
  }, [trackShareClicked, mainActions, openShapePopup]);

  const handleLoginClick = useCallback(() => {
    history.push(ROUTES.SIGN_IN, { state: { from: window.location.pathname } });
  }, [history]);

  return {
    handleShareClick,
    handleLoginClick,
  };
};
